import { bbox, Geometry, GeometryCollection } from '@turf/turf';

export const mapboxBbox = (
  geometry: Geometry | GeometryCollection,
): [number, number, number, number] =>
  bbox(geometry) as [number, number, number, number];
